module.exports = __webpack_public_path__ + "static/media/background.3ea1333c.jpg";